module.exports = __webpack_public_path__ + "1c6b7c81067f3021b6235699c10c4a37.png";